import Moment from 'moment';

export const hoursFormat = 'hh:mm A';

export const formatDurationToHours = (timeSpan, format = hoursFormat) => Moment().startOf('year').add(timeSpan).format(format);
